const tabs = ['ALL', 'LPA', 'CHOL', 'HDL', 'LDL', 'TRG'];

export { tabs };
